import * as React from "react";
import type { SVGProps } from "react";
const SvgIntegrate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M32.184 2.543 56.876 17.1v28.548L32.184 60.574 6.95 45.654v-28.56L32.184 2.543ZM8.7 18.105v26.55l23.475 13.88 22.952-13.874V18.1L32.175 4.568 8.699 18.105Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M12.445 18.845a4.267 4.267 0 1 1-8.533 0 4.267 4.267 0 0 1 8.533 0Z"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M8.179 21.362a2.517 2.517 0 1 0 0-5.033 2.517 2.517 0 0 0 0 5.033Zm0 1.75a4.267 4.267 0 1 0 0-8.533 4.267 4.267 0 0 0 0 8.533Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M12.445 44.442a4.267 4.267 0 1 1-8.533 0 4.267 4.267 0 0 1 8.533 0Z"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M8.179 46.958a2.517 2.517 0 1 0 0-5.033 2.517 2.517 0 0 0 0 5.033Zm0 1.75a4.267 4.267 0 1 0 0-8.533 4.267 4.267 0 0 0 0 8.533Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M60.088 18.845a4.267 4.267 0 1 1-8.533 0 4.267 4.267 0 0 1 8.533 0Z"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M55.821 21.362a2.517 2.517 0 1 0 0-5.033 2.517 2.517 0 0 0 0 5.033Zm0 1.75a4.267 4.267 0 1 0 0-8.533 4.267 4.267 0 0 0 0 8.533Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M60.088 44.442a4.267 4.267 0 1 1-8.533 0 4.267 4.267 0 0 1 8.533 0Z"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M55.821 46.958a2.517 2.517 0 1 0 0-5.033 2.517 2.517 0 0 0 0 5.033Zm0 1.75a4.267 4.267 0 1 0 0-8.533 4.267 4.267 0 0 0 0 8.533Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M36.977 59.733a4.267 4.267 0 1 1-8.533 0 4.267 4.267 0 0 1 8.534 0Z"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M32.71 62.25a2.517 2.517 0 1 0 .001-5.033 2.517 2.517 0 0 0 0 5.033Zm0 1.75a4.267 4.267 0 1 0 .001-8.533 4.267 4.267 0 0 0 0 8.533Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M36.621 4.267a4.267 4.267 0 1 1-8.533 0 4.267 4.267 0 0 1 8.533 0Z"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M32.355 6.783a2.517 2.517 0 1 0 0-5.033 2.517 2.517 0 0 0 0 5.033Zm0 1.75a4.267 4.267 0 1 0 0-8.533 4.267 4.267 0 0 0 0 8.533Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="m31.428 17.348-.293 2.489c-.06.504-.392.934-.865 1.12l-4.273 1.672a1.375 1.375 0 0 1-1.34-.19l-1.89-1.454-1.445 1.445 1.503 2.104c.275.385.333.883.154 1.32l-1.669 4.079c-.189.463-.615.786-1.112.845l-2.494.293v2.213l2.49.293c.504.06.934.392 1.12.864l1.676 4.285c.169.433.108.922-.162 1.3l-1.506 2.108 1.44 1.44 2.082-1.636c.404-.317.951-.383 1.419-.17l4.093 1.86c.408.186.7.558.783.999l.446 2.38h2.056l.293-2.494c.059-.496.382-.922.845-1.111l4.079-1.669c.437-.179.935-.12 1.32.154l2.104 1.502 1.464-1.464-1.503-2.104a1.375 1.375 0 0 1-.154-1.32l1.669-4.078c.19-.463.615-.787 1.112-.845l2.494-.294v-2.213l-2.489-.293a1.375 1.375 0 0 1-1.12-.864l-1.672-4.274a1.375 1.375 0 0 1 .19-1.34l1.454-1.889-1.445-1.445-2.104 1.503a1.375 1.375 0 0 1-1.32.153l-4.079-1.668a1.375 1.375 0 0 1-.845-1.112l-.293-2.494h-2.213Zm-1.7-.536a1.375 1.375 0 0 1 1.366-1.215h2.88c.697 0 1.284.522 1.366 1.215l.306 2.606 3.683 1.506 2.194-1.567a1.375 1.375 0 0 1 1.771.147l1.903 1.903c.489.488.539 1.263.118 1.81L43.79 25.2l1.513 3.867 2.597.305a1.375 1.375 0 0 1 1.214 1.366v2.88c0 .697-.521 1.284-1.214 1.365l-2.606.307-1.506 3.682 1.567 2.194c.39.547.328 1.297-.147 1.772l-1.914 1.914a1.375 1.375 0 0 1-1.771.146l-2.194-1.567-3.683 1.507-.306 2.605a1.375 1.375 0 0 1-1.366 1.215h-2.7c-.662 0-1.23-.472-1.352-1.122l-.467-2.495-3.709-1.686-2.164 1.7c-.548.43-1.33.384-1.822-.108l-1.9-1.9a1.375 1.375 0 0 1-.146-1.771l1.572-2.201-1.52-3.886-2.598-.306a1.375 1.375 0 0 1-1.214-1.365v-2.88c0-.698.522-1.285 1.214-1.366l2.606-.306 1.507-3.683-1.567-2.194a1.375 1.375 0 0 1 .146-1.771l1.903-1.903a1.375 1.375 0 0 1 1.81-.118l1.983 1.525 3.867-1.513.306-2.597Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M32.464 37.477a5.37 5.37 0 1 0 0-10.74 5.37 5.37 0 0 0 0 10.74Zm0 1.75a7.12 7.12 0 1 0 0-14.24 7.12 7.12 0 0 0 0 14.24Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIntegrate;
